<ng-container *ngIf="data">
  <div [attr.data-value]="data" [ngClass]="customClass">
    <span p500UITooltip [tooltipData]="data" [longContent]="true" class="mr-8">{{
      data.length > length ? (data | slice : 0 : length) + '...' : data
    }}</span>
    <span
      *ngIf="!showCopiedMessage; else copied"
      style="cursor: pointer"
      class="ml-auto c-field-value__text -link -primary"
      p500UITooltip
      i18n-tooltipData="@@common.copy_to_clipboard"
      tooltipData="Copy to clipboard"
      (click)="copy($event)"
    >
      <p500-ui-icon name="buttons-copy-big"></p500-ui-icon>
    </span>
  </div>
</ng-container>
<div *ngIf="!data">
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</div>

<ng-template #copied>
  <span
    style="cursor: pointer"
    class="ml-auto c-field-value__text -link -primary"
    p500UITooltip
    i18n-tooltipData="@@common.copied"
    tooltipData="Copied!"
    (click)="copy($event)"
  >
    <p500-ui-icon name="buttons-copy-big"></p500-ui-icon>
  </span>
</ng-template>
